export const GRANT_ACCESS_TO = 'grantAccessTo';
export const DECLINE_ACCESS_TO = 'declineAccessTo';
